import { getEnv } from "../../runtimeEnv";

export const apiVersion = 'v1.0';

export const AccountLogoSize = 1;  // in MB

export const defaultTenant = "testdev";

export const default_size = 12;

export const default_size_mcp = 100;

export const default_size_messages = 30;

export const defaultCharacterLimit = 3;

export const CODER_MAX_FILE_SIZE_UPLOAD = 3 * 1024 * 1024; // 3MB

export const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB

export const CODER_MAX_FILES_UPLOAD = 5;

// Default max size for all image uploads 
export const MAX_IMAGE_UPLOAD_SIZE = 5 * 1024 * 1024; // 5MB

export const folderRegex = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_]+$/;

// Same as folderRegex, but also allows spaces (used in storage folder creation)
export const folderNameWithSpaceRegex = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_][a-zA-Z0-9_ ]*$/;

export const validBranchNameRegex = /^(?!\/|-)(?!.*\.\.)(?!.*\/\/)(?!.*\.lock$)(?!.*\.$)[^\s~^:?*[\\]+(?<!\/)$/;


// Allowed image types for all image uploads.
export const ALLOWED_IMAGE_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/svg+xml",
];

export const ALLOWED_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "svg"];

export const APP_VERSION = getEnv("REACT_APP_VERSION");

export const COOKIE_CONSENT_KEY = "cookie-consent";

/** Set to "1" in sessionStorage immediately before full page reload after a tenant switch; `public/index.html` shows a loading overlay until the app clears it. */
export const TENANT_SWITCH_SESSION_KEY = "saTenantSwitchInProgress";
export const TENANT_SWITCH_OVERLAY_ID = "sa-tenant-switching-overlay";

export const llmTypes = [
    { label: "OpenAI", value: "OpenAI" },
    { label: "Azure OpenAI", value: "Azure OpenAI" },
    { label: "AWS Bedrock", value: "AWS_Bedrock" },
    { label: "Google Gemini", value: "Google Gemini" },
    { label: "Meta Llama", value: "Meta Llama" },
    { label: "Ollama", value: "Ollama" },
    { label: "Claude AI", value: "Claude AI" },
    { label: "Mistral AI", value: "Mistral AI" },
    { label: "IBM WatsonX", value: "IBM WatsonX" }
];

export const websocketModuleType = {
    NOTIFICATION: "NOTIFICATION",
    STORAGE: "STORAGE",
    CLUSTER: "CLUSTER",
    POD: "POD",
    CODER: "CODER",
    AGENT_EXECUTION: "AGENT_EXECUTION",
    WORKFLOW_STATUS: "WORKFLOW_STATUS",
    CHECKPOINT_RESTORE: "CHECKPOINT_RESTORE",
    SCM: "SCM"
}

export const messageStatus = {
    FAILED: "FAILED",
    PENDING: "PENDING",
    RUNNING: "RUNNING",
    COMPLETED: "COMPLETED",
    ERROR: "ERROR",
    CANCELLED: "CANCELLED",
    TIMEOUT: "TIMEOUT",
    SUCCESS: "SUCCESS"
}

export const buildType = {
    APP: "APP",
    AGENT: "AGENT",
    APP_AGENT: "APP_AGENT",
    AGENT_EXECUTION: "AGENT_EXECUTION",
    WEBSITE: "WEBSITE"
    
}
export const projectJobStatus = {
    PREPARING: "preparing",
    PROCESSING: "processing",
    STREAMING: "streaming",
    INTERRUPT: "interrupt",
    SUCCESS: "success",
    COMPLETED: "completed",
    FAILED: "failed"
}

export const websocketAction = {
    REFRESH: "REFRESH",
    RESULT: "RESULT"
}

export const projectType = {
    NEW: "NEW",
    RESUME: "RESUME",
    INTERRUPT: "INTERRUPT",
    /** Import existing application from GitHub or local archive */
    IMPORT: "IMPORT",
    PLAN: "PLAN",
}

export const planAction = {
    START: "start",
    RESPOND: "respond",
    UPDATE: "update",
    REFINE: "refine",
}

export const planQuestionType = {
    SINGLE_SELECT: "single_select",
    MULTI_SELECT: "multi_select",
    TEXT: "text",
}

export const PLAN_MESSAGE_KIND = "plan";

export const projectImportSource = {
    GITHUB: "GITHUB",
    UPLOAD: "UPLOAD",
}

export const providerLogo = {
    'google': 'https://cdn-icons-png.flaticon.com/512/281/281764.png',
    'microsoft': 'https://cdn-icons-png.flaticon.com/512/732/732221.png',
    'github': 'https://cdn-icons-png.flaticon.com/512/733/733553.png',
    'slack': 'https://cdn-icons-png.flaticon.com/512/2111/2111615.png',
    'aws': 'https://cdn-icons-png.flaticon.com/512/873/873107.png',
    'salesforce': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'hubspot': 'https://cdn-icons-png.flaticon.com/512/5968/5968875.png',
    'zoho': 'https://www.zoho.com/crm/images/crm-icon.svg',
    'dropbox': 'https://cdn-icons-png.flaticon.com/512/888/888857.png',
    'shopify': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'stripe': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'paypal': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'facebook': 'https://cdn-icons-png.flaticon.com/512/174/174848.png',
    'linkedin': 'https://cdn-icons-png.flaticon.com/512/174/174857.png',
    'twitter': 'https://cdn-icons-png.flaticon.com/512/733/733579.png',
    'youtube': 'https://cdn-icons-png.flaticon.com/512/174/174883.png',
    'spotify': 'https://cdn-icons-png.flaticon.com/512/174/174872.png',
    'zoom': 'https://cdn-icons-png.flaticon.com/512/5969/5969020.png',
    'discord': 'https://cdn-icons-png.flaticon.com/512/5969/5969103.png',
    'telegram': 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
    'whatsapp': 'https://cdn-icons-png.flaticon.com/512/124/124034.png',
    'notion': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'trello': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'jira': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'asana': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'gitlab': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'mongodb': 'https://cdn-icons-png.flaticon.com/512/5968/5968342.png',
    'mysql': 'https://cdn-icons-png.flaticon.com/512/5968/5968313.png',
    'postgresql': 'https://cdn-icons-png.flaticon.com/512/5968/5968342.png',
    'azure': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'okta': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
    'auth0': 'https://cdn-icons-png.flaticon.com/512/5968/5968332.png',
};

export const websocketUrl = getEnv("REACT_APP_WEBSOCKET_URL");

export const PREVIEW_UI_TEMPLATE = getEnv("REACT_APP_PREVIEW_UI_TEMPLATE");

export const PREVIEW_BACKEND_URL = getEnv("REACT_APP_PREVIEW_BACKEND_TEMPLATE");

export const PREVIEW_BACKEND_API_URL = getEnv("REACT_APP_PREVIEW_BACKEND_API_TEMPLATE");

export const PREVIEW_DATABASE_URL = getEnv("REACT_APP_PREVIEW_DATABASE_TEMPLATE");

export const SOURCE_SYNC_URL = getEnv("REACT_APP_SOURCE_SYNC");


// localhost urls

export const PREVIEW_UI_LOCALHOST = "http://localhost:5173";

export const PREVIEW_BACKEND_API_LOCALHOST = "http://localhost:8000/openapi.json";

export const PREVIEW_DATABASE_URL_LOCALHOST = "http://localhost:10000/";

export const PREVIEW_SOURCE_SYNC_URL_LOCALHOST = "http://localhost:10001/";

export const websocketRetryInterval = 30000;

/** Poll interval for trial credit usage while project chat is streaming */
export const TRIAL_POLL_MS = 20000;

export const csv = "far fa-file-excel mr-2";
export const ipynb = "fas fa-book-open mr-2";
export const image = "fas fa-file-image mr-2";
export const defaultIcon = "far fa-file mr-2";

export const DF_EXTRACT_FOLDER = ".sagentx_extract/jobs/";
export const DF_EXTRACT_PATH_VIEW = "jobs/";

// ----------------------------------------------------------------------
// 🔍 Get base domain
// ----------------------------------------------------------------------
export const baseDomain = () => {
    const { origin, hostname, pathname } = window.location;
    const pathParts = pathname.split('/').filter(Boolean);
  
    if (hostname === 'localhost' && pathParts.length > 0) {
        return `${origin}/${pathParts[0]}`;
    }

    return origin;
};

let redirectUri = window.location.origin + "/auth/oauth2-redirect";

const state = Math.random().toString(36).substring(2);

export const GOOGLE_AUTH_URL = `${getEnv("REACT_APP_AUTH0_DOMAIN")}/authorize?` +
  `client_id=${encodeURIComponent(getEnv("REACT_APP_AUTH0_CLIENTID"))}` +
  `&response_type=code` +
  `&scope=${encodeURIComponent("openid profile email")}` +
  `&redirect_uri=${encodeURIComponent(redirectUri)}` +
  `&connection=${encodeURIComponent(getEnv("REACT_APP_AUTH0_GCP_CONNECTION"))}` +
  `&state=${encodeURIComponent(state)}`;

  export const MICROSOFT_AUTH_URL = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
  `client_id=${encodeURIComponent(getEnv("REACT_APP_AZURE_CLIENT_ID"))}` +
  `&response_type=code` +
  `&scope=${encodeURIComponent("openid profile email")}` +
  `&redirect_uri=${encodeURIComponent(redirectUri)}` +
  `&response_mode=query` +
  `&state=${encodeURIComponent(state)}`;


// Common event-hander-messge
export const MESSAGE_OFFLINE = "message-offline";
export const OFFLINE = "offline";
export const WEBSOCKET_RECONNECT = "message-ws-reconnect";
export const RECONNECT = "reconnect";
export const WF_ACTION_TYPES = {
    init : 'INIT',
    execute : 'EXECUTE',
    modify : 'MODIFY',
    info : 'INFO'
}

export const notebookEditorData = {
    fontSize: "15px",
    theme: "tomorrow",
    tabSize: 4,
    options: ["autoComplete", "wrapEnabled", "lineNumber"]
}

export const handlers = [
    {
        value: "AIHandler",
        label: "AI Handler",
        srcPath: "superagentx.handler",
        icon: "",
        description: "",
        link: ""
    },
    {
        value: "ElasticsearchHandler",
        label: "Elastic Search Handler",
        srcPath: "superagentx.handler",
        icon: "",
        description: "Elasticsearch is a powerful, open-source search and analytics engine based on Apache Lucene. It quickly stores, searches, and analyzes large amounts of data by creating indexes, rather than searching the text directly. With a document-based structure and easy-to-use REST APIs, it processes and returns data in JSON format, offering fast and scalable performance.",
        link: "https://docs.superagentx.ai/examples/handlers/exa"
    },
    {
        value: "ExaHandler",
        label: "Exa Handler",
        srcPath: "superagentx.handler",
        icon: "",
        description: "Exa helps you locate precise content online using embeddings-based search. Its API offers three key features: Page Search: Find web pages through natural language queries, with an option to use traditional keyword searches if needed. Similar Page Discovery: Input a link to identify and retrieve pages with related content or meaning.",
        link: "https://docs.superagentx.ai/examples/handlers/exa"
    },
    {
        value: "FinancialHandler",
        label: "Financial Handler",
        srcPath: "superagentx.handler",
        icon: "",
        description: "The Financial Data Handler is a tool that helps get important financial information from online sources. It allows businesses or individuals to easily access real-time data like stock prices, company financial details, and income statements. This information can be used for tracking market trends, analyzing a company’s performance, or making better investment decisions.",
        link: "https://docs.superagentx.ai/examples/handlers/financial_data"
    },
    {
        value: "OpenAPIHandler",
        label: "OpenAPI Handler",
        srcPath: "superagentx.handler",
        icon: "",
        description: "The OpenAPIHandler class provides a simple way to interact with APIs that follow the OpenAPI specification. It allows you to load the OpenAPI specification from either a URL or a local file in JSON or YAML format. You can easily retrieve all available API endpoints, get the supported HTTP methods for each endpoint, and view detailed information about specific operations.",
        link: "https://docs.superagentx.ai/examples/handlers/openapi"
    },
    {
        value: "EmailHandler",
        label: "Email Handler",
        srcPath: "superagentx.handler",
        icon: "fa-solid fa-envelope",
        description: "The EmailHandler is a simple and effective tool for managing email communication in your applications. It allows you to send emails easily, handle multiple recipients, and include attachments, making it perfect for both personal and professional use",
        link: "https://docs.superagentx.ai/examples/handlers/email"
    },
    {
        value: "SerperDevToolHandler",
        label: "Serper Dev Tool Handler",
        srcPath: "superagentx.handler",
        icon: "",
        description: "The Serper.dev API provides a way to conduct real-time web searches, mainly leveraging Google’s search capabilities, and is useful for tasks requiring quick access to up-to-date information. It focuses on returning specific search results, such as snippets and relevant URLs, making it ideal for developers who need web-based insights integrated into their applications.",
        link: "https://docs.superagentx.ai/examples/handlers/serper_dev"
    },
    {
        value: "ConfluenceHandler",
        label: "Confluence Handler",
        srcPath: "superagentx_handlers.atlassian",
        icon: "fa-brands fa-confluence",
        description: "A Confluence handler is a tool or API that allows developers to interact with Confluence, a popular collaboration and documentation platform by Atlassian. This handler makes it easier to manage and manipulate content within Confluence, such as creating, updating, and retrieving pages, spaces, and user information.",
        link: "https://docs.superagentx.ai/examples/handlers/atlassian/confluence"
    },
    {
        value: "JiraHandler",
        label: "Jira Handler",
        srcPath: "superagentx_handlers.atlassian",
        icon: "fa-brands fa-jira",
        description: "The JiraHandler class is a tool that helps developers easily connect to Jira and perform common operations like creating, updating, and managing issues or projects. If you’ve ever used Jira for tracking bugs, managing tasks, or following project progress, this class makes it simpler to automate those activities using Python",
        link: "https://docs.superagentx.ai/examples/handlers/atlassian/jira"
    },
    {
        value: "AWSEC2Handler",
        label: "AWSEC2 Handler",
        srcPath: "superagentx_handlers.aws",
        icon: "",
        description: "",
        link: ""
    },
    {
        value: "AWSS3Handler",
        label: "AWSS3 Handler",
        srcPath: "superagentx_handlers.aws",
        icon: "",
        description: "Amazon S3 is a cloud storage service on AWS that lets you store different types of files, like photos, audio, and videos, as objects. It offers high scalability and security, making it easy to store and access any amount of data from anywhere, anytime. S3 also provides features like high availability, strong security, and smooth integration with other AWS services",
        link: "https://docs.superagentx.ai/examples/handlers/aws/s3"
    },
    {
        value: "HubSpotHandler",
        label: "HubSpot Handler",
        srcPath: "superagentx_handlers.crm",
        icon: "fa-brands fa-hubspot",
        description: "This HubSpotHandler class simplifies managing interactions with the HubSpot API, offering seamless methods for creating, retrieving, and managing contacts, companies, deals, and tickets within a HubSpot environment. By encapsulating common operations, it ensures that users can efficiently communicate with the API using both synchronous and asynchronous workflows.",
        link: "https://docs.superagentx.ai/examples/handlers/hubspot"
    },
    {
        value: "AmazonHandler",
        label: "Amazon Handler",
        srcPath: "superagentx_handlers.ecommerce",
        icon: "",
        description: "AmazonHandler, for interacting with the Amazon data API using RapidAPI. It uses to fetch Amazon product data and customer reviews",
        link: "https://docs.superagentx.ai/examples/handlers/E-commerce/amazon"
    },
    {
        value: "BestbuyHandler",
        label: "Bestbuy Handler",
        srcPath: "superagentx_handlers.ecommerce",
        icon: "",
        description: "",
        link: ""
    },
    {
        value: "FlipkartHandler",
        label: "Flipkart Handler",
        srcPath: "superagentx_handlers.ecommerce",
        icon: "",
        description: "Flipkart, a leading e-commerce platform in India, offers millions of products across categories like electronics, fashion, home appliances, and groceries. Efficient product search is crucial to its ecosystem, helping users quickly discover relevant items through filters, recommendations, and keyword-based search functionality",
        link: "https://docs.superagentx.ai/examples/handlers/E-commerce/flipkart"
    },
    {
        value: "WalmartHandler",
        label: "Walmart Handler",
        srcPath: "superagentx_handlers.ecommerce",
        icon: "",
        description: "A Walmart handler is a tool that makes it easy for developers to connect their apps or websites to Walmart’s system. With this tool, businesses can access Walmart’s product listings, prices, stock levels, and availability in real-time. It helps automate tasks like searching for products, tracking inventory, and monitoring price changes. This handler is very useful for e-commerce websites, price comparison tools, and inventory management systems.",
        link: "https://docs.superagentx.ai/examples/handlers/E-commerce/walmart"
    },
    {
        value: "CalenderHandler",
        label: "Calender Handler",
        srcPath: "superagentx_handlers.google",
        icon: "fa-solid fa-calendar",
        description: "The Google Calendar Handler is a utility designed to simplify interactions with the Google Calendar API. This handler enables users to authenticate, access, and manage their calendar events efficiently. It provides methods for retrieving events for specific time frames, such as today, the upcoming week, or the next month, as well as filtering events based on specific types",
        link: "https://docs.superagentx.ai/examples/handlers/Google/calender"
    },
    {
        value: "GmailHandler",
        label: "Gmail Handler",
        srcPath: "superagentx_handlers.google",
        icon: "fa-solid fa-envelope",
        description: "The Gmail Handler is a specialized tool designed to interact with the Gmail API, enabling users to manage their email accounts programmatically. This handler simplifies the process of accessing user profiles, sending emails, and creating draft emails. It uses OAuth 2.0 for authentication and provides a user-friendly interface to perform various email-related tasks asynchronously.",
        link: "https://docs.superagentx.ai/examples/handlers/Google/gmail"
    },
    {
        value: "AmazonWebHandler",
        label: "Amazon Web Handler",
        srcPath: "superagentx_handlers.websitecrawler",
        icon: "",
        description: "",
        link: ""
    },
    {
        value: "CsvHandler",
        label: "Csv Handler",
        srcPath: "superagentx_handlers",
        icon: "fa-solid fa-file-csv",
        description: "The method leverages a query string provided by the user to generate a filter condition based on the columns of the CSV file. This condition is used to extract relevant data from the CSV and return it in a structured format. The filtering logic is generated by an external LLM (Large Language Model) client, which receives a prompt based on the CSV’s structure",
        link: "https://docs.superagentx.ai/examples/handlers/csv_cli"
    },
    {
        value: "ScrapeHandler",
        label: "Scrape Handler",
        srcPath: "superagentx_handlers",
        icon: "",
        description: "A scrape handler is a tool or part of a program that helps you “scrape” data from websites. When you want to collect information from a webpage, like product prices, weather data, or news headlines, a scrape handler is the part of the system that goes to the website, gets the data, and then processes it for you",
        link: "https://docs.superagentx.ai/examples/handlers/scrape"
    },
    {
        value: "SQLHandler",
        label: "SQL Handler",
        srcPath: "superagentx_handlers",
        icon: "fa-solid fa-database",
        description: "A SQL handler refers to a tool or interface that simplifies the process of interacting with SQL databases. Its main purpose is to help developers run SQL queries, manage data, and connect to databases with minimal complexity. It abstracts away repetitive tasks such as writing complex SQL syntax, handling connections, and managing query results, making it easier to work with databases.",
        link: "https://docs.superagentx.ai/examples/handlers/sql"
    },
    {
        value: "TwitterHandler",
        label: "Twitter Handler",
        srcPath: "superagentx_handlers",
        icon: "fa-brands fa-twitter",
        description: "",
        link: ""
    },
    {
        value: "WeatherHandler",
        label: "WeatherHandler",
        srcPath: "superagentx_handlers",
        icon: "fa-solid fa-bolt",
        description: "A weather handler is a tool or library that helps developers integrate weather data into applications. It works by retrieving real-time or forecasted weather information from external sources, such as weather APIs, and presenting it in a way that is easy to use in applications like websites, mobile apps, or IoT devices",
        link: "https://docs.superagentx.ai/examples/handlers/weather"
    },
    {
        value: "WikipediaHandler",
        label: "Wikipedia Handler",
        srcPath: "superagentx_handlers",
        icon: "fa-brands fa-wikipedia-w",
        description: "A Wikipedia handler is a tool or library that simplifies access to Wikipedia’s vast knowledge base. It enables developers to retrieve and manipulate Wikipedia content programmatically, making it useful for applications requiring summarized, factual, or historical information from the platform. This handler streamlines interactions with the Wikipedia API, ensuring easy extraction of data such as articles, search results, and metadata.",
        link: "https://docs.superagentx.ai/examples/handlers/wikipedia"
    }
]

export const models = [
    { label: "OpenAI-gpt-4o", value: "gpt-4o" },
    { label: "OpenAI-gpt-4", value: "gpt-4" },
    { label: "OpenAI-gpt-4o-2024-05-13", value: "gpt-4o-2024-05-13" },
    { label: "OpenAI-gpt-4o-2024-08-06", value: "gpt-4o-2024-08-06" },
    { label: "OpenAI-gpt-4-turbo-2024-04-09", value: "gpt-4-turbo-2024-04-09" },
    { label: "OpenAI-gpt-4o-mini-2024-07-18", value: "gpt-4o-mini-2024-07-18" },
    { label: "OpenAI-gpt-4o-mini", value: "gpt-4o-mini" },
    { label: "Bedrock-anthropic.claude-3-5-sonnet-20241022-v2:0", value: "anthropic.claude-3-5-sonnet-20241022-v2:0" },
    { label: "Bedrock-anthropic.claude-3-5-haiku-20241022-v1:0", value: "anthropic.claude-3-5-haiku-20241022-v1:0" },
    { label: "Bedrock-anthropic.claude-instant-v1:2:100k", value: "anthropic.claude-instant-v1:2:100k" },
    { label: "Bedrock-anthropic.claude-3-sonnet-20240229-v1:0", value: "anthropic.claude-3-sonnet-20240229-v1:0" },
    { label: "Bedrock-anthropic.claude-3-haiku-20240307-v1:0", value: "anthropic.claude-3-haiku-20240307-v1:0" },
    { label: "Bedrock-anthropic.claude-3-opus-20240229-v1:0", value: "anthropic.claude-3-opus-20240229-v1:0" },
    { label: "Bedrock-anthropic.claude-3-5-sonnet-20240620-v1:0", value: "anthropic.claude-3-5-sonnet-20240620-v1:0" },
    { label: "Bedrock-cohere.command-r-v1:0", value: "cohere.command-r-v1:0" },
    { label: "Bedrock-cohere.command-r-plus-v1:0", value: "cohere.command-r-plus-v1:0" },
    { label: "Bedrock-meta.llama3-1-8b-instruct-v1:0", value: "meta.llama3-1-8b-instruct-v1:0" },
    { label: "Bedrock-meta.llama3-1-70b-instruct-v1:0", value: "meta.llama3-1-70b-instruct-v1:0" },
    { label: "Bedrock-meta.llama3-1-405b-instruct-v1:0", value: "meta.llama3-1-405b-instruct-v1:0" },
    { label: "Bedrock-mistral.mistral-large-2402-v1:0", value: "mistral.mistral-large-2402-v1:0" },
    { label: "Bedrock-mistral.mistral-large-2407-v1:0", value: "mistral.mistral-large-2407-v1:0" }
];

export const provisionerService = {
    kubernetesCluster: 'KUBERNETES_CLUSTER',
    virtualMachine: 'VIRTUAL_MACHINE',
    storage: 'STORAGE',
    containerCluster: 'CONTAINER_CLUSTER'
}

export const extractTypes ={
    EXTRACT : "EXTRACT"
}

export const HTTP_METHODS = {
    POST : "POST",
    GET : "GET",
    DELETE : "DELETE",
    PUT : "PUT"
}

export const API_RESPONSE = {
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
    FAILURE: "FAILURE"
}

export const cloudTypes = {
    AZURE: "AZURE",
    AZURE_VM: "AZURE_VM",
    AWS: "AWS",
    AMAZON: "AMAZON",
    SPARK: "SPARK",
    PYTHON: "PYTHON",
    GOOGLE: "GOOGLE"
}

export const zipTypeExtensions = ["zip", "tar", "rar", "gz"];
export const hasHTMLTags = (str) => /<\/?[^>]+(>|$)/g.test(str);

export const API_VERSION = "V1"
export const API_BASE_URL = getEnv("REACT_APP_API_BASE_URL")
export const STORAGE_BASE_URL = getEnv("REACT_APP_STORAGE_BASE_URL")
export const UTILS_BASE_URL = getEnv("REACT_APP_UTILS_BASE_URL")
export const STORAGE_EXTERNAL_MOUNT_PATH = "/mnt/";
export const STORAGE_DEFAULT_MOUNT_PATH = "/content/";
export const MAX_DOWNLOAD_FILES = 1
export const MAX_COPY_MOVE_FILES = 50
export const DF_TINY_URL = "https://tinyurl.com/api-create.php?url="
export const CALLBACKTIMEOUT = 1000;

export const CLUSTERSTATUS = {
    PENDING: "PENDING",
    STARTING: "STARTING",
    CREATING: "CREATING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    PROVISIONING: "PROVISIONING",
    DELETING: "DELETING",
    RESTARTING: "RESTARTING",
    STOPPED: "STOPPED",
    DELETED: "DELETED",
    NOT_FOUND: "NOT_FOUND",
    UNKNOWN: "UNKNOWN",
    FAILED: "FAILED",
    ERROR: "ERROR"
};

export const Deploymentactions = {
    PENDING: "PENDING",
    DEPLOYING: "DEPLOYING",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    CREATING: "CREATING",
    STOPPING: "STOPPING",
    TERMINATING: "TERMINATING",
    STARTERD: "STARTED",
    STOPPED: "STOPPED",
    TERMINATED: "TERMINATED",
    RESTARTING: "RESTARTING",
    FAILED: "FAILED",
    STOP_VM: "STOP_VM",
    START_VM: "START_VM",
    TERMINATE_VM: "TERMINATE_VM",
    RELAUNCH_VM: "RELAUNCH_VM",
    DELETE_VM: "DELETE_VM"
};

export const workflowEvents = {
    EVENT_REQUEST_PENDING: "request_pending",
    EVENT_REQUEST_INIT: "request_init",
    EVENT_REQUEST_PREPARING: "request_preparing",
    EVENT_REQUEST_EXECUTE: "request_execute",
  
    EVENT_PIPE_FLOW_START: "pipe_flow_start",
  
    EVENT_AGENT_EXECUTE_START: "agent_execute_start",
    EVENT_AGENT_EXECUTE: "agent_execute",
    EVENT_AGENT_LLM_EXECUTE: "agent_llm_execute",
    EVENT_AGENT_VERIFY_GOAL_USAGE: "agent_verify_goal_usage",
    EVENT_AGENT_ITERATION_COMPLETE: "agent_iteration_complete",
    EVENT_AGENT_EXECUTE_COMPLETE: "agent_execute_complete",
    EVENT_AGENT_EXECUTE_ERROR: "agent_execute_error",
  
    EVENT_REQUEST_FAILED: "request_failed",
    EVENT_REQUEST_COMPLETED: "request_completed",
  };



export const statusMap = {
    Pending: 'Pending...',
    Preparing: 'Preparing..',
    Running: 'Running..',
    result_execute: 'Preparing..',
    Pipe_flow_start: 'Running..',
    request_execute: 'Running..',
    agent_execute_start: 'Agent Executing..',
    agent_execute: 'Agent Executing..',
    agent_execute_complete: 'Agent Executing Completed',
    request_completed: 'Completed',
    agent_execute_error: 'Error',
    agent_execute_failed: 'Error',
    agent_execute_timeout: 'Error',
    agent_execute_cancelled: 'Error',
    request_failed: 'Error',
    workflow_started: 'Pending..'
};

const apiEndPoints = {
    api: {
        base: { url: API_BASE_URL },
        app: {
            config: 'api/app/configure',
            getAppById: 'api/app/get/by/',
            getConfigById: 'api/app/configure/get/by/',
            create_app : 'api/app/create',
            get_app : 'api/app/get/by/list',
            getTypes : 'api/app/get/types',
            re_configure: 'api/app/reconfigure/by/',
            createVersion: 'api/app/version/by/',
            restoreVersion: 'api/app/restore/by/',
            captureThumbnail: 'api/project/app/thumbnail/'

        },
        auth: {
            login: 'auth0/login',
            passwordLogin: 'login/auth/signin',
            verifyOTP: 'auth0/verify-otp',
            oauth2Callback: 'auth0/social/login',
            validateAuth: 'login/auth/validate',
            loginVerify: 'auth0/login-verify',
            switchTenant: 'auth0/switch-tenant',
            desktopAuthorize: 'auth0/oauth/authorize',
            desktopToken: 'auth0/oauth/token',
        },
        oAuth:{
            getOAuth: 'api/auth/authorize/',
            deleteOAuth: 'api/auth/delete/by/',
            getConnectedAppById: 'api/auth/get/by/',
            getConnectedAppsListByUser: 'api/auth/get/by/user',
            getConnectedApps: 'api/auth/get/',
            getManualOAuth: 'api/auth/authorize/manual/',
        },
        usermanagement:{
            get_userlist: 'api/tenant/list/',
            create_user: 'api/tenant/register/user',
            delete_user: 'api/tenant/',
            updatePassword: 'api/user/updatepassword'
        },
        user:{
            get_user: 'api/user/me'
        },
        Extract: {
            getExtractionList: '/middleware/extract/list',
            addInstruction: '/middleware/extract/instruction/add',
            getInstruction: '/middleware/extract/instruction/list',
            getListProject: 'api/' + apiVersion + '/middleware/extract/project/get',
            createExtract: 'api/extract/project/create',
            searchExtract: 'api/extract/project/search/by/',
            updateExtract: 'api/extract/project/update/by/',
            deleteExtract: 'api/extract/project/delete/by/',
            getAllExtractionList:'api/extract/project/all',
            getExtractionListById:'api/extract/project/get/',  
            getExtractRuns: 'api/extract/all' ,
            runExtract: 'api/extract/run' ,
            getExtractStatus: 'api/extract/get/status/',
            getExtractRunById: 'api/extract/get/run/',
            getExtractRunByProjectId: 'api/extract/get/project/',
 
        },
        
        Prompt: {
            filterPrompt: 'api/prompt/filter',
            updatePrompt: 'api/prompt/update/by/',
            createPrompt: 'api/prompt/create'
        },
        storageConfig: {
            postStorageConfig: 'api/cloud/storage',
            getAllStorageConfig: 'api/cloud/storage/list',
            getAllStorageConfigbyId: 'api/cloud/storage/get/',
            deleteStorageConfigbyId: 'api/cloud/storage/',
            updateStorageConfig: 'api/cloud/storage/',
        },
        cloud:{
            get_cloud: 'api/cloud/provisioner/list',
            create_cloud: 'api/cloud/provisioner/operation',
            delete_cloud: 'api/cloud/provisioner/operation',
            getprovisionerByService: 'api/cloud/provisioner/list/by/service/',
        },
        cluster: {
            get_cluster: 'api/cloud/provisioner/list',
            create_cluster: 'api/cluster/k8s',
            delete_cluster: 'api/cluster/k8s/',
            forcedelete_cluster: 'api/cluster/k8s/force/',
            cluster_status: 'api/cluster/k8s/status/',
            stopcluster: 'api/cluster/k8s/stop/',
            restartcluster: 'api/cluster/k8s/restart/',
            startcluster: 'api/cluster/k8s/start/',
            getZones: 'api/cloud/provisioner/list/by/service/',
            getk8s: 'api/cluster/k8s',
            getprovisionerByService: 'api/cloud/provisioner/list/by/service/',
            save_cluster_config: 'api/cluster/workload',
            get_cluster_config: 'api/cluster/workload',
            list_pods: 'api/pod/list',
            pod_live: 'api/pod/live/',
            get_pod: 'api/pod/get/',
            delete_pod: 'api/pod/delete/pod/',
        },
        machineTypes:{
            getInstanceRegion: "api/cloud/vm/instance/by"
        },
        oauth: {
            getAuthProvider: 'api/auth/get/'
        },
        deployment: {
            getAll: 'api/deployment/get/all',
            getByAppId: 'api/deployment/get/by',
            postDeploy: 'api/deployment',
            terminateDeployment: 'api/deployment/terminate/',
            deleteDeployment: 'api/deployment/',
            deploymentAction: 'api/deployment/action',
            relaunchDeployment: "api/deployment/relaunch/by/",
            getLiveStatus: "api/deployment/live/status/by/"
        },
        workflow: {
            config: 'api/app/configure',
            getAppById: 'api/app/get/by/',
            getConfigById: 'api/app/configure/get/by/',
            create_app : 'api/project',
            create_workflow : 'api/project/workflow',
            publish_workflow : 'api/project/orchestrator/publish',
            get_orchestrator : 'api/project/orchestrator/get',
            execute_orchestrator : 'api/project/orchestrator/execute',
            restore_orchestrator : 'api/project/orchestrator/restore',
            execute_workflow : 'api/project/workflow/execute',
            generate_workflow : 'api/project/workflow/generate',
            getMcp: 'api/mcp/search',
            get_app : 'api/app/get/by/list',
            getTypes : 'api/app/get/types',
            re_configure: 'api/app/reconfigure/by/',
            createVersion: 'api/app/version/by/',
            restoreVersion: 'api/app/restore/by/',
            getWorkflowHistory: 'api/project/workflow/history',
            getWorkflowExecution:'api/project/workflow/execute/',
            approval:'auth/workflow/approval'
        },
        appBuilder: {
            createProject: 'api/project/app/create',
            xrayProject: 'api/project/app/xray/create',
            getProject: 'api/project/app/get',
            getProjectById: 'api/project/app/get/by',
            updateProject: 'api/project/app/',
            shareProject: 'api/project/app/share',
            checkProjectAccess: 'api/project/app/access',
            projectMembers: 'api/project/app/get/by/members',
            revokeProjectMember: 'api/project/app/members/revoke/by'
        },
        codeIntelligence: {
            importGithub: 'code-review/api/code-intelligence/import/github',
            importUpload: 'code-review/api/code-intelligence/import/upload',
            jobStatus: 'code-review/api/code-intelligence/jobs/',
            result: 'code-review/api/code-intelligence/',
            overview: 'code-review/api/code-intelligence/',
            products: 'code-review/api/code-intelligence/products',
            product: 'code-review/api/code-intelligence/products/',
            reanalyze: 'code-review/api/code-intelligence/products/',
            modernize: 'code-review/api/code-intelligence/products/',
            getLocal: "code-review/api/code-intelligence/get/local"
        },
        source: {
            connect: 'api/source/connect',
            branch: 'api/source/branch',
            switchBranch: 'api/source/branch/switch',
            sync: 'api/source/sync',
            getMapping: 'api/source/mapping',
            fetch: 'api/source/fetch',
            compress: 'api/source/compress'
        },
        database: {
            getDatabaseInfo: 'db/api/v1/databases',
            getDatabaseTables: 'db/api/v1/tables',
            getTableData: 'db/api/v1/get/table',
            getTableSchema: 'db/api/v1/table/schema'
        },
        billing: {
            getProjectCreditUsage: 'api/credit/usage/project',
            getProjectCreditUsageSummary: 'api/credit/usage-summary/project',
            getAccountCreditUsage: 'api/credit/usage/account',
            getAccountCreditUsageSummary: 'api/credit/usage-summary/account',
            getTrialUsageSummary: 'api/credit/trial/usage-summary/account',
        },
        analytics: {
            getAccountDashboard: 'api/workflow/agents/observability/analytics',
            getAccountTokensUsageSummary: 'api/workflow/agents/observability/tokens/usage-summary/account',
        },
        metrics: {
            create: 'api/evaluation/metrics',
            filter: 'api/evaluation/metrics/filter',
            getById: 'api/evaluation/metrics/',
            update: 'api/evaluation/metrics/',
            delete: 'api/evaluation/metrics/'
        },
        llmProxy: {
            list: 'api/gateway/list',
            create: 'api/gateway/create',
            delete: 'api/gateway/remove',
            update: 'api/gateway/update'
        },
        policy: {
            metadata: 'api/policies/metadata',
            list: 'api/policies',
            categories: 'api/policies/categories',
            create: 'api/policies',
            update: 'api/policies/',
            delete: 'api/policies/',
            preview: 'api/policies/preview',
        },
        policyGroups: {
            list: 'api/policy-groups',
            create: 'api/policy-groups',
            get: 'api/policy-groups/',
            policies: 'api/policy-groups/',
            update: 'api/policy-groups/',
            delete: 'api/policy-groups/',
        },
        governance: {
            audits: 'api/governance/audits',
        },
        dashboard: {
            getSummary: 'api/evaluation/summary',
            getAnalytics: 'api/evaluation/analytics',
            getExecutionDetail: 'api/evaluation/executions/', // + executionId
            getTopAgents: 'api/evaluation/agents',
            getExecutionsList: 'api/evaluation/executions',
        },
        projectVersions: {
            getProjectVersion: "api/project-versions/projects",
            restore: "api/project-versions/restore"
        },
        organisation: {
            getAll: 'api/admin/organisation/all',
        },
        marketplace: {
            createAccount: "/api/marketplace/account",
            validate: "/api/marketplace/account/validate",
        },
        stack: {
            create: 'api/stack',
            getAll: 'api/stack',
            getById: 'api/stack/'
        }
    },
    fileapi: {
        fileJobs: {
            extractFile: 'api/middleware/storage/zip',
            copyFile: 'api/middleware/storage/copy',
            moveFile: 'api/middleware/storage/move',
            compressFile: 'api/middleware/storage/compress',
            trashFolder: 'api/middleware/storage/trash',
            deleteFolder: 'api/middleware/storage/delete',
            restoreFile: 'api/middleware/storage/restore',
            renameFile: 'api/middleware/storage/rename',
            SaveFileVersion: 'api/middleware/storage/version/versioning',
            restoreVersionObjects: 'api/middleware/storage/version/restore',
            getPendingJobs: 'api/middleware/storage/pending-jobs',
            ViewOriginalVersion: 'api/middleware/storage/version/original',
            GetStorageJobId: 'api/middleware/storage/job/'
        }
    },
    storageApi: {
        base: { url: STORAGE_BASE_URL },
        buckets: {
            getBuckets: '/api/v1/buckets',
        },
        prefixs:{
            createPrefix: '/api/v1/buckets/prefix',
            deletePrefix: '/api/v1/buckets/prefix'
        },  
        objects: {
            downloadApp: 'api/v1/buckets/object/app',
            listObjects: 'api/v1/buckets/objects',
            trashObject: 'api/v1/buckets/objects/trash',
            downloadVersionApp: 'api/v1/buckets/object/app/version',
            uploadApp: 'api/v1/buckets/object/app',
            uploadObjects: 'api/v1/buckets/object',
            versionList: 'api/v1/buckets/objects/app/version',
            downloadObject: 'api/v1/buckets/object',
            renameFile: 'api/v1/buckets/object/rename',
            copyFile: 'api/v1/buckets/object/copy',
            restoreFile: 'api/v1/buckets/object/restore',
            deleteFolder: 'api/v1/buckets/object',
            trashFolder: 'api/v1/buckets/objects/trash',
            uploadExtract: 'api/v1/buckets/object/extract',
            downloadExtract: 'api/v1/buckets/object/extract',

        }
    }
    ,
    utils:{
        base: {url: UTILS_BASE_URL},
        common: {
            llms: "utils/api/v1/llms",
            models: "utils/api/v1/llm/models",
            handlers: "utils/api/v1/handlers",
        },
        codeview: {
            getSource: "/source-view/source/api/v1/get/project/"
        },
        policySync: {
            getPolicy: 'policy-sync/policy',
        }
    },

    codeSync: {
        base: { url: SOURCE_SYNC_URL },
        syncCode: {
            codesync_endpoint: 'source-sync/update/source',
            imageUpload: 'source-sync/upload/image',
        },
    
    },
    extract_ai: {
        // validate_url: APPS_AI_ENDPOINT + "threeway/api/v1/threeway/request"
      }
}

export const validEmailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const ACCESS_TOKEN = 'accessToken';
export const SIGNIN_AUTH_TOKEN = 'AuthToken';

export default apiEndPoints;